import styled from 'styled-components'

export const CheckoutCreditCardSuccessContainer = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 380px;
  padding: 120px 0;
  
  svg {
    height: 50px;
    width: 50px;
    margin-bottom: 10px;
  }

  button {
    margin-top: 30px;
    padding: 0 30px;
  }
`